<template>
  <div>
    <h2>Opening Hours</h2>
    <p class="text-muted">
      These hours are used by the older Boxx admin tools. The boxx.ie landing
      page now reads opening hours from Smartbooks shopfront settings
      (app.smartbooks365.com → Settings → Shopfront), including per-day notes
      such as “Walk-ins only”.
    </p>
    <b-card class="mt-3" v-for="day in days" :key="day">
      <div class="row align-items-center">
        <div class="col-8 col-md-6">
          <h5 class="m-0">{{ day | startCase }}</h5>
        </div>
        <div class="col-4 col-md-2">
          <b-form-checkbox
            class="pull-right mb-0"
            v-model="editableStore.daysOpen[day]"
            @input="tryUpdateStore"
          >
            Open
          </b-form-checkbox>
        </div>
        <div class="col-12 col-md-2">
          <vue-ctk-date-time-picker
            :id="'opening-time__' + day"
            label="Opening Time"
            v-model="editableStore.openingTimes[day]"
            format="HH:mm"
            formatted="hh:mm a"
            :only-time="true"
            :right="true"
            :minute-interval="15"
            required
            no-clear-button
            :disabled="!editableStore.daysOpen[day]"
            @input="tryUpdateStore"
          ></vue-ctk-date-time-picker>
        </div>
        <div class="col-12 col-md-2">
          <vue-ctk-date-time-picker
            :id="'closing-time__' + day"
            label="Closing Time"
            v-model="editableStore.closingTimes[day]"
            format="HH:mm"
            formatted="hh:mm a"
            :only-time="true"
            :right="true"
            :minute-interval="15"
            required
            no-clear-button
            :disabled="!editableStore.daysOpen[day]"
            @input="tryUpdateStore"
          ></vue-ctk-date-time-picker>
        </div>
        <!-- <div class="col-12 col-md-2">
          <vue-ctk-date-time-picker
            :id="'lunch-time__' + day"
            label="Lunch Hour"
            v-model="editableStore.lunchTimes[day]"
            format="HH:mm"
            formatted="hh:mm a"
            :only-time="true"
            :right="true"
            :minute-interval="15"
            required
            no-clear-button
            :disabled="!editableStore.daysOpen[day]"
            @input="tryUpdateStore"
          ></vue-ctk-date-time-picker>
        </div> -->
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

export default {
  components: {
    VueCtkDateTimePicker
  },
  data() {
    return {
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ],
      editableStore: null
    };
  },
  methods: {
    ...mapActions({
      updateStore: 'stores/updateStore'
    }),
    tryUpdateStore() {
      try {
        this.updateStore(this.editableStore);
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      }
    }
  },
  filters: {
    startCase: _.startCase
  },
  computed: mapGetters({
    store: 'stores/store'
  }),
  created() {
    this.editableStore = _.cloneDeep(this.store);
  }
};
</script>
<style lang="scss" scoped>
@import '~vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
</style>
